import { createSlice } from "@reduxjs/toolkit";

export interface BusinessLeaderDashboardSlice {
  selectedSharedUidBui: [];
  selectedStartDate: string;
  selectedEndDate: string;
  selectedPeriod: string;
  selectedDimensions: [];
  selectedType: string;
  selectedInterval: string;
  selectedDaysLeftForPeriod: string;
  selectedAll: boolean;
  dateChangeClicked: string;
  websites: [];
}

const initialState: BusinessLeaderDashboardSlice = {
  selectedSharedUidBui: [],
  selectedStartDate: "",
  selectedEndDate: "",
  selectedPeriod: "",
  selectedDimensions: [],
  selectedType: "site",
  selectedInterval: "",
  selectedDaysLeftForPeriod: "",
  selectedAll: false,
  dateChangeClicked: "",
  websites: [],
};

const businessLeaderDashboardSlice = createSlice({
  name: "businessLeaderDashboard",
  initialState,
  reducers: {
    setSelectedSharedUidBui: (state, action) => {
      state.selectedSharedUidBui = action.payload;
    },
    setStartDate: (state, action) => {
      state.selectedStartDate = action.payload;
    },
    setEndDate: (state, action) => {
      state.selectedEndDate = action.payload;
    },
    setSelectedPriode: (state, action) => {
      state.selectedPeriod = action.payload;
    },
    setselectedDimensione: (state, action) => {
      state.selectedDimensions = action.payload;
    },
    setSelectedType: (state, action) => {
      state.selectedType = action.payload;
    },
    setSelectedInterval: (state, action) => {
      state.selectedInterval = action.payload;
    },
    setSelectedDaysLeftForPeriod: (state, action) => {
      state.selectedDaysLeftForPeriod = action.payload;
    },
    setSelectedAll: (state, action) => {
      state.selectedAll = action.payload;
    },
    setDateChangeClicked: (state, action) => {
      state.dateChangeClicked = action.payload;
    },
    setWebsites: (state, action) => {
      state.websites = action.payload;
    },
  },
});

export const {
  setSelectedSharedUidBui,
  setStartDate,
  setEndDate,
  setSelectedPriode,
  setselectedDimensione,
  setSelectedType,
  setSelectedInterval,
  setSelectedDaysLeftForPeriod,
  setSelectedAll,
  setDateChangeClicked,
  setWebsites,
} = businessLeaderDashboardSlice.actions;

export default businessLeaderDashboardSlice.reducer;
